// extracted by mini-css-extract-plugin
export default {"title":"tzy4Gg","mobile":"DutUYb"};